// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"234":"81904a28","618":"aa8ddc3b","966":"d796ea1d"}[chunkId] + ".css";
};